/* eslint-disable */
import React, { useState, useRef } from "react";
import { Outlet, Link } from "react-router-dom";
import Logo from "../../components/logo/Logo";
import DashboardNavigation from "../../components/dashboard_navigation/DashboardNavigation";
import useNotificationContext from "../../hooks/useNotificationContext";

function Dashboard() {
	const mobileNavigationRef = useRef(null);
	const [isFullScreen, setIsFullScreen] = useState(false);
	const { unreadNotifications } = useNotificationContext();

	const toggleMobileMenu = () => {
		if (mobileNavigationRef.current) {
			mobileNavigationRef.current.classList.toggle("hidden");
		}
	};

	return (
		<div className="flex h-screen overflow-hidden bg-white">
			{/* Mobile Sidebar */}
			<div
				ref={mobileNavigationRef}
				className={`fixed inset-0 z-40 md:hidden hidden`}
				role="dialog"
				aria-modal="true"
			>
				<div className="fixed inset-0 bg-success-800 backdrop-blur-sm" aria-hidden="true"></div>
				<div className="relative flex-1 flex flex-col max-w-xs w-full bg-success-800 backdrop-blur-xl pt-5 pb-4">
					<div className="flex items-center justify-between px-4 mb-5">
						<Logo color="white" />
						<button onClick={toggleMobileMenu}>
							<span className="material-icons-outlined text-white">close</span>
						</button>
					</div>
					<div className="flex-1 overflow-y-auto">
						<DashboardNavigation isFullScreen={false} />
					</div>
				</div>
			</div>

			{/* Desktop Sidebar */}
			<div
				className={`hidden md:flex md:flex-col md:fixed md:inset-y-0 transition-all duration-300
    ${isFullScreen ? "md:w-16" : "md:w-64"}`}
			>
				<div className="flex flex-col flex-grow pt-5 bg-success-800 backdrop-blur-xl overflow-y-auto relative">
					{/* Logo + Toggle */}
					<div className="flex items-center justify-between flex-shrink-0 px-4 mb-5">
						{!isFullScreen && <Logo color="white" />}
						<button
							onClick={() => setIsFullScreen(!isFullScreen)}
							className="hover:bg-white/10 p-1 rounded-md transition-all duration-200 absolute right-0"
						>
							<span className="material-icons-outlined text-white">
								{isFullScreen ? "keyboard_double_arrow_right" : "keyboard_double_arrow_left"}
							</span>
						</button>
					</div>

					<DashboardNavigation
						isFullScreen={isFullScreen}
						setIsFullScreen={setIsFullScreen}
					/>
				</div>
			</div>

			{/* Main Content */}
			<div
				className={`flex flex-col flex-1 transition-all duration-300 overflow-hidden
          ${isFullScreen ? "md:pl-16" : "md:pl-64"}`}
			>
				{/* Top Bar */}
				{/* <div className="sticky top-0 z-10 flex items-center justify-between h-16 bg-white shadow px-4">
					<button
						onClick={toggleMobileMenu}
						className="md:hidden p-2 rounded-md hover:bg-gray-200 transition-all duration-200"
					>
						<span className="sr-only">Open sidebar</span>
						<svg
							className="h-6 w-6"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="2"
								d="M4 6h16M4 12h16M4 18h7"
							/>
						</svg>
					</button>

					<div className="flex items-center ml-auto">
						<Link
							to="notification"
							className="relative p-2 rounded-full hover:bg-gray-200 transition-all duration-200"
						>
							<span className="sr-only">View notifications</span>
							<span
								className={`material-icons-outlined text-3xl ${unreadNotifications ? "text-danger-500" : "text-gray-400"
									}`}
							>
								notifications
							</span>
							{unreadNotifications ? (
								<span className="absolute -top-1 -right-1 w-5 h-5 text-xs flex items-center justify-center bg-red-500 text-white rounded-full">
									{unreadNotifications < 100
										? unreadNotifications
										: "100+"}
								</span>
							) : null}
						</Link>
					</div>
				</div> */}

				{/* Page Content */}
				<main className="p-4 overflow-y-auto flex-1">
					<Outlet />
				</main>
			</div>
		</div>
	);
}

export default Dashboard;